import { render, staticRenderFns } from "./LandingGlp1.vue?vue&type=template&id=0e526aef&scoped=true"
import script from "./LandingGlp1.vue?vue&type=script&lang=js"
export * from "./LandingGlp1.vue?vue&type=script&lang=js"
import style0 from "./LandingGlp1.vue?vue&type=style&index=0&id=0e526aef&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e526aef",
  null
  
)

export default component.exports